import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	paginationContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	iconCell: {
		width: 73,
	},
	actionCell: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	tipCard: {
		backgroundColor: '#e4eefb',
		color: '#15263e',
		boxShadow: 'none',
		padding: '0.632rem',
		borderRadius: '20px',
		display: 'flex',
		alignItems: 'center',
		flexShrink: 3,
		width: 'fit-content',
	},
	tip: {
		...theme.typography.pagination,
	},
	icon: {
		marginRight: theme.spacing(1),
	},
	cellStyle: {
		whiteSpace: 'nowrap',
	},
}));
